// src/types/recent-searches/recentSearchHelpers.ts
var recentSearchDestinationKey = (d) => {
  if (d.area_id) return `area:${d.area_id}`;
  if (d.place_id) return `place:${d.place_id}`;
  const city = d.city?.trim().toLowerCase();
  if (city) return `city:${city}`;
  if (d.lat != null && d.lng != null) return `near:${d.lat.toFixed(4)},${d.lng.toFixed(4)}`;
  return null;
};
var isRecentSearchLive = (rs, todayIso) => rs.check_in === null || rs.check_in === void 0 || rs.check_in >= todayIso;
var toPropertySearchIntent = (rs) => {
  const intent = { place: rs.destination_label };
  if (rs.area_id) intent.areaId = rs.area_id;
  if (rs.place_id) intent.placeId = rs.place_id;
  if (rs.check_in) intent.checkIn = rs.check_in;
  if (rs.check_out) intent.checkOut = rs.check_out;
  if (rs.guests && rs.guests > 1) intent.guests = rs.guests;
  const f = rs.filters ?? {};
  if (f.types?.length) intent.types = f.types;
  if (f.bedrooms !== void 0) intent.bedrooms = f.bedrooms;
  if (f.bathrooms !== void 0) intent.bathrooms = f.bathrooms;
  if (f.amenities?.length) intent.amenities = f.amenities;
  if (f.minPrice !== void 0) intent.minPrice = f.minPrice;
  if (f.maxPrice !== void 0) intent.maxPrice = f.maxPrice;
  return intent;
};
var toSlotBrowseParams = (rs) => {
  const params = { city: rs.city ?? rs.destination_label };
  if (rs.check_in) params.date = rs.check_in;
  if (rs.guests) params.seats = rs.guests;
  if (rs.filters?.category) params.category = rs.filters.category;
  return params;
};
var stayFilters = (p) => {
  const filters = {};
  if (p.types?.length) filters.types = p.types;
  if (p.bedrooms !== void 0) filters.bedrooms = p.bedrooms;
  if (p.bathrooms !== void 0) filters.bathrooms = p.bathrooms;
  if (p.amenities?.length) filters.amenities = p.amenities;
  if (p.minPrice !== void 0) filters.minPrice = p.minPrice;
  if (p.maxPrice !== void 0) filters.maxPrice = p.maxPrice;
  return filters;
};
var stayRecentSearchInput = (p) => {
  const label = p.place?.trim();
  if (!label) return null;
  const input = { destination_label: label, filters: stayFilters(p) };
  if (p.areaId) input.area_id = p.areaId;
  else if (p.placeId) input.place_id = p.placeId;
  else input.city = label;
  if (p.checkIn) input.check_in = p.checkIn;
  if (p.checkOut) input.check_out = p.checkOut;
  if (p.guests && p.guests > 0) input.guests = p.guests;
  return input;
};
var slotRecentSearchInput = (p) => {
  const city = p.city?.trim();
  if (!city) return null;
  const input = { destination_label: city, city, filters: {} };
  if (p.date) input.check_in = p.date;
  if (p.seats && p.seats > 0) input.guests = p.seats;
  if (p.category) input.filters = { category: p.category };
  return input;
};
var recentSearchSignature = (kind, input) => {
  const key = recentSearchDestinationKey(input);
  if (!key) return null;
  const filters = input.filters ?? {};
  const filterPart = Object.keys(filters).sort().map((k) => `${k}=${JSON.stringify(filters[k])}`).join("&");
  return [
    kind,
    key,
    input.check_in ?? "",
    input.check_out ?? "",
    input.guests ?? "",
    filterPart
  ].join("|");
};

export {
  recentSearchDestinationKey,
  isRecentSearchLive,
  toPropertySearchIntent,
  toSlotBrowseParams,
  stayRecentSearchInput,
  slotRecentSearchInput,
  recentSearchSignature
};
